import { postSma } from "service/apiSma";

const CheckUserPinSma = async (userId, pin) => {
  try {
    const response = await postSma(`/user/${userId}/checkPin`, {
      pin: pin,
    });
    return response;
  } catch (error) {
    console.error("Error CheckUserPinSma:", error);
    throw error;
  }
};

export default CheckUserPinSma;
